export const sensitivityOptions = Array(11).fill(null).map((_, index) => {
  const percentage = 5 * (index + 1)
  return {
    value: percentage / 100,
    label: `${ percentage }%`
  }
})